import gql from 'graphql-tag';
import { BENEFICIARY_TRANSACTION_FRAGMENT } from './fragment_beneficiary';
import { CARD_PAN_PHYSICAL_FRAGMENT } from './fragment_card';
import { CATEGORY_TRANSACTION_FRAGMENT } from './fragment_category';
import { RECURRENCE_TRANSACTION_FRAGMENT } from './fragment_recurrence';
import { ATTACHEMENT_TRANSACTION_FRAGMENT } from './fragment_attachment';

const LAST_TRANSACTION_CARD_FRAGMENT = gql`
  fragment LastTransactionCardInfo on Transaction {
    id
    title
    dateTransaction
    executionDate
    amount
    currency
    modality
    modalityType
    source
    transactionState
    treezorTransactionId
    note
    ref
    timer
    transactionType
    beneficiary {
      ...BeneficiaryTransactionInfo
    }
    recurrence {
      ...RecurrenceTransactionInfo
    }
    category {
      ...CategoryTransactionInfo
    }
    account {
      id
      person {
        id
        name
        firstName
        company {
          legalName
          sapheerBanks {
            wallets {
              bic
              iban
            }
          }
        }
      }
    }
    card {
      ...CardPanPhysicalInfo
    }
    attachments {
      ...AttachmentTransactionInfo
    }
    viewed
  }
  ${ATTACHEMENT_TRANSACTION_FRAGMENT}
  ${BENEFICIARY_TRANSACTION_FRAGMENT}
  ${RECURRENCE_TRANSACTION_FRAGMENT}
  ${CATEGORY_TRANSACTION_FRAGMENT}
  ${CARD_PAN_PHYSICAL_FRAGMENT}
`;

export { LAST_TRANSACTION_CARD_FRAGMENT };
